module.exports = __webpack_public_path__ + "static/media/Gilroy-UltraLight.e968a112.woff";